import { render, staticRenderFns } from "./QuestionMenu.vue?vue&type=template&id=9926e8f2&scoped=true&lang=true&"
import script from "./QuestionMenu.vue?vue&type=script&lang=js&"
export * from "./QuestionMenu.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMenu.vue?vue&type=style&index=0&id=9926e8f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9926e8f2",
  null
  
)

export default component.exports